<template>
<!--  <div class="new-header" :class="(bgRouterArr.indexOf(routerPath) !== -1 || scrollTop > 0) ? 'new-header-course' : ''">-->
  <div class="new-header">
    <div class="inner">
      <img :src="headerLogo" class="logo"/>
      <div class="right-wrap">
        <nav>
          <div
            v-for="(item, index) in menuList"
            :key="index"
            class="nav-item"
          >
            <div :class="item.path.indexOf(routerPath) !== -1  ? 'item-wrap active' : 'item-wrap'">
              <span @click="toJump(item.path)" class="name-span">{{ item.name }}</span>
              <div class="border-div"></div>
            </div>
            <div class="item-children">
              <div
                v-for="(items, indexs) in item.children"
                :key="indexs"
                @click="toJump(items.path)"
                :class="routerPath === items.path ? 'active' : ''"
              >
                {{ items.name }}
              </div>
            </div>
          </div>
        </nav>
<!--        <div class="login-wrap">-->
<!--&lt;!&ndash;          <div class="login-div" v-if="UnionID" @click="logout">退出登录</div>&ndash;&gt;-->
<!--          <el-dropdown :hide-on-click="false" v-if="UnionID">-->
<!--            <span class="el-dropdown-link">-->
<!--              <img :src="headimgurl"/>-->
<!--              <span>{{ NickName }}</span>-->
<!--            </span>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--              <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--          <div class="login-not" v-if="!UnionID" @click="goLogin('/home')">-->
<!--&lt;!&ndash;            <img :src="notLoginIcon"/>&ndash;&gt;-->
<!--            <div class="reg-text">注册</div>-->
<!--            <span>|</span>-->
<!--            <div class="login-text">登录</div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div id="animatedModal" class="clr1-bg" :class="isShowLoginAlert ? 'zoomIn' : 'zoomOut'" v-show="isShowLoginAlert">
      <div class="modal-content" @click.stop="closeLogin">
<!--        <div class="scan-code" v-show="isShowLoginAlert">-->
<!--          <div id="qrcode_login_box"></div>-->
<!--        </div>-->
        <login-popup v-if="isShowLoginAlert"></login-popup>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import loginPopup from './loginPopup'
import CookieUtil from '../../utils/cookieUtil'
// let headerLogo = require('../../assets/newImage/headerLogo.png')
let headerLogo = require('../../assets/newImage/header-logo.png')
let notLoginIcon = require('../../assets/newImage/notLogin-icon.png')
export default {
  components: {
    loginPopup
  },
  data () {
    return {
      menuList: [
        {name: '首页', path: '/home', children: []},
        {
          name: '解决方案',
          path: '/science,/AI,/spaceflight',
          children: [
            { name: '科学探索教育解决方案', path: '/science' },
            { name: '人工智能创新教育解决方案', path: '/AI' },
            { name: '航天特色教育解决方案', path: '/spaceflight' }
          ]
        },
        {name: '开源鸿蒙', path: '/openHarmony', children: []},
        {name: '创课评测', path: '/evaluating', children: []},
        {name: '课程中心', path: '/course', children: []},
        {name: '联系我们', path: '/BusinessCooperation', children: []}
        // {name: '航天大赛', path: '/competitionApply'}
        // {name: '产品介绍', path: '/product'},
        // {name: '社会责任', path: '/socialResponsibility'},
        // {name: '商务合作', path: '/BusinessCooperation'},
        // {name: '精准教学', path: ''}
      ],
      bgRouterArr: ['/information', '/course', '/businessLicense', '/publications', '/courseIntroduction', '/dealers_map', '/news_details'],
      notLoginIcon,
      headerLogo,
      StoreUrl: '',
      LogoUrl: '',
      NickName: '',
      headimgurl: '',
      UnionID: '',
      cosUrl: process.env.COS_HOST,
      isShowLoginAlert: false,
      routerPath: '',
      scrollTop: 0
    }
  },
  created () {
    let v = this
    this.LogoUrl = Cookie.get('LogoUrl')
    this.StoreUrl = Cookie.get('StoreUrl')
    this.NickName = Cookie.get('NickName')
    this.headimgurl = Cookie.get('headimgurl')
    this.headimgurl = Cookie.get('headimgurl')
    this.UnionID = Cookie.get('UnionID')
    this.ShopAddressUrl = Cookie.get('ShopAddressUrl')
    this.Bus.$off('loginPopup-close')
    this.Bus.$on('loginPopup-close', () => {
      v.isShowLoginAlert = false
    })
    this.Bus.$off('loginSuccessHeader')
    this.Bus.$on('loginSuccessHeader', () => {
      v.getRender()
      v.isShowLoginAlert = false
    })
    this.Bus.$off('routerShop-header')
    this.Bus.$on('routerShop-header', shopInfo => {
      v.getRender()
    })
    /* 扫码事件 */
    this.Bus.$off('scanEvent')
    this.Bus.$on('scanEvent', function (e) {
      console.log(e)
      if (e.show) {
        v.goLogin()
      } else {
        v.getRender()
      }
    })
    this.getPath()
    window.addEventListener('scroll', this.initHeight)
  },
  destroyed () {
    window.removeEventListener('scroll', this.initHeight)
  },
  watch: {
    '$route': 'getPath',
    isShowLoginAlert (val) {
      if (val) {
        // let hrefUrl = window.location.href
        // let shopUrl = ''
        // let arr = hrefUrl.split('.')
        // if (arr[0].indexOf('http://') !== -1) {
        //   if (arr.length > 4) {
        //     shopUrl = arr[0].replace('http://', '')
        //   }
        // }
        // if (arr[0].indexOf('https://') !== -1) {
        //   if (arr.length > 3) {
        //     shopUrl = arr[0].replace('https://', '')
        //   }
        // }
        // let domainParams = ''
        // if (['', null, 'null', undefined, 'undefined'].indexOf(shopUrl) === -1) {
        //   domainParams = `&domain=${shopUrl}`
        // }
        // this.$nextTick(() => {
        //   new WxLogin({ // eslint-disable-line
        //     self_redirect: false,
        //     id: 'qrcode_login_box', // 需要显示的容器id
        //     // appid: process.env.APP_ID, // 公众号appid wx*******
        //     appid: process.env.APP_ID_SCAN, // 公众号appid wx*******
        //     scope: 'snsapi_login', // 网页应用只用写 snsapi_login
        //     // redirect_uri: encodeURIComponent(process.env.Redirect_Course_Uri), // 授权成功后回调的url后端准备的回调地址, 用来接收code
        //     // redirect_uri: encodeURIComponent(`${process.env.Redirect_Url_Scan_code}?type=2${domainParams}`), // 授权成功后回调的url后端准备的回调地址, 用来接收code
        //     redirect_uri: encodeURIComponent(`${process.env.Redirect_Url_Scan_code}?type=kidsWebsite&routerUrl=${sessionStorage.loginCbRouter}`), // 授权成功后回调的url后端准备的回调地址, 用来接收code
        //     state: 'STATE#wechat_redirect',
        //     style: '',
        //     // href: "https://www.kindercloud.net/public/wechat_qrcode_login.css" // 外部css文件url，需要https自定义样式链接
        //     href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIyMHB4ICFpbXBvcnRhbnQ7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmUgIWltcG9ydGFudDt9Ci5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMjIwcHggIWltcG9ydGFudDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZSAhaW1wb3J0YW50O30KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyICFpbXBvcnRhbnQ7fQ==' // 外部css文件url，需要https自定义样式链接
        //   })
        // })
      } else {
        // clearInterval(this.qrcodeTime)
        document.body.style.overflow = ''
      }
    }
  },
  methods: {
    closeLogin () {
      if (this.routerPath !== '/course') {
        this.isShowLoginAlert = false
      }
    },
    initHeight () {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },
    getPath () {
      this.routerPath = this.$route.path
      // console.log(this.$route.path)
    },
    getRender () {
      this.LogoUrl = Cookie.get('LogoUrl')
      this.StoreUrl = Cookie.get('StoreUrl')
      this.NickName = Cookie.get('NickName')
      this.headimgurl = Cookie.get('headimgurl')
      this.UnionID = Cookie.get('UnionID')
      this.ShopAddressUrl = Cookie.get('ShopAddressUrl')
    },
    toJump (url) {
      if (url === '/science,/AI,/spaceflight') {
        return false
      }
      if (url === '/course') {
        this.goLogin()
      } else {
        this.$router.push(url)
      }
    },
    toJump2 () {
      // 精准教学
      const state = new Date().getTime()
      window.open(`https://sso.521ke.com/oauth2/authorize?client_id=0172f49a-67a0-4daf-ac45-9c3231598e20&response_type=code&redirect_uri=${encodeURIComponent('https://www.521ke.com/dashboard')}&state=${state}`)
      // location.href = `https://sso.521ke.com/oauth2/authorize?client_id=0172f49a-67a0-4daf-ac45-9c3231598e20&response_type=code&redirect_uri=${encodeURIComponent('https://www.521ke.com/dashboard')}&state=${state}`
    },
    goLogin (loginCbRouter) {
      window.open(`https://dfck.course.xdf-zhjy.com`)
      // this.isShowLoginAlert = true
      // sessionStorage.loginCbRouter = loginCbRouter
      // sessionStorage.loginCbRouter = this.routerPath
      // document.body.style.overflow = 'hidden'
    },
    async logout () {
      CookieUtil.clear()
      this.headimgurl = ''
      this.NickName = ''
      this.UnionID = ''
      this.$message({
        message: '退出登录',
        type: 'success'
      })
      // this.$notify({
      //   title: '成功',
      //   message: '退出登录!',
      //   type: 'success',
      //   offset: 100,
      //   duration: 1500
      // })
      this.$router.push('/home')
    },
    getStoreInfo () {
      let hrefUrl = window.location.href
      let shopUrl = ''
      let arr = hrefUrl.split('.')
      if (arr[0].indexOf('http://') !== -1) {
        if (arr.length > 4) {
          shopUrl = arr[0].replace('http://', '')
        }
      }
      if (arr[0].indexOf('https://') !== -1) {
        if (arr.length > 3) {
          shopUrl = arr[0].replace('https://', '')
        }
      }
      return new Promise(async (resolve, reject) => {
        try {
          let result = await this.$http.get('/KCStore/GetStoreAndGroupID', {
            params: {
              Url: shopUrl
            }
          })
          let shopInfo = result.data
          Cookie.set('KCStoreID', shopInfo.KCStoreID, { expires: 0.5 })
          Cookie.set('KCGroupID', shopInfo.KCGroupID, { expires: 0.5 })
          Cookie.set('ShopAddressUrl', shopInfo.ShopAddressUrl, { expires: 0.5 })
          Cookie.set('StoreBanner', shopInfo.StoreBanner, { expires: 0.5 })
          Cookie.set('StoreName', shopInfo.StoreName, { expires: 0.5 })
          Cookie.set('LogoUrl', shopInfo.LogoUrl, { expires: 0.5 })
          Cookie.set('StoreUrl', shopInfo.StoreUrl, { expires: 0.5 })
          Cookie.set('Store_Mobile', shopInfo.Mobile, { expires: 0.5 })
          resolve(result.data)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 1366px){
  .new-header .inner {
    max-width: 1080px;
  }
}
@media screen and (min-width: 1680px){
  .new-header .inner {
    max-width: 1280px;
  }
}
.new-header{
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.5s;
  background-color: rgba(255,255,255,1);
  //box-shadow: 0 4px 16px 0 rgba(0,0,0,0.1);
  .inner{
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .logo-text{
      font-size: 16px;
      color: #fff;
    }
    .logo{
      height: 60px;
      cursor: pointer;
    }
    .right-wrap{
      display: flex;
      align-items: center;
      position: relative;
      bottom: -3px;
      nav{
        display: flex;
        align-items: center;
        .nav-item{
          padding: 0 20px;
          position: relative;
          .item-wrap{
            display: flex;
            flex-direction: column;
            align-items: center;
            .name-span{
              cursor: pointer;
              font-size: 16px;
              color: #000;
            }
            .border-div{
              margin-top: 10px;
              width: 60%;
              border-bottom: 3px solid transparent;
            }
            &.active{
              .name-span{
                color: #265b9f;
                font-weight: 550;
              }
              .border-div{
                border-bottom: 3px solid #265b9f;
              }
            }
          }
          .item-children{
            position: absolute;
            left: -30%;
            top: 40px;
            background-color: #fff;
            box-shadow: 0 0 5px #e2e2e2;
            height: 0;
            overflow: hidden;
            transition: height 0.2s;
            div{
              padding: 0 15px;
              white-space: nowrap;
              font-size: 14px;
              line-height: 40px;
              &:hover{
                cursor: pointer;
                color: #265b9f;
              }
              &.active{
                color: #265b9f;
              }
            }
          }
          &:hover{
            .item-children{
              height: 120px;
            }
          }
        }
      }
      .login-wrap{
        display: flex;
        align-items: center;
        padding-left: 20px;
        padding-bottom: 13px;
        .el-dropdown-link{
          display: flex;
          align-items: center;
          cursor: pointer;
          img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            //border: 1px solid rgba(0,0,0,0.3);
          }
          span{
            margin-left: 10px;
            font-size: 16px !important;
            color: #000;
          }
        }
        .login-not{
          color: #000;
          display: flex;
          align-items: center;
          .reg-text{
            color: #cb4600;
            cursor: pointer;
          }
          .login-text{
            color: #000;
            cursor: pointer;
          }
          span{
            font-size: 14px;
            margin: 0 5px;
          }
          img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
            //border: 1px solid rgba(0,0,0,0.3);
          }
        }
      }
    }
  }
  #animatedModal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    overflow: hidden;
    opacity: 1;
    animation-duration: 0.6s;
  }
  .clr1-bg {
    z-index: -9999;
    //background-color: rgba(255, 255, 255, 0.85) !important;
    color: #1e1e1e;
  }
  .modal-content {
    min-height: 100%;
    padding: 30px 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 300;
    box-sizing: border-box;
    .scan-code{
      padding: 10px 15px 0 15px;
      position: relative;
      margin: 0 auto;
      box-shadow: 0 0 30px rgba(0,0,0,0.5);
      //width: 350px;
      max-width: 100%;
      background-color: white;
    }
  }
  @keyframes zoomIn {
    0% {
      opacity: 0;
      transform: scale3d(.3,.3,.3)
    }
    50% {
      opacity: 1
    }
  }
  .zoomIn {
    z-index: 1000;
    //background-color: rgba(255, 255, 255, 0.85);
    background-color: rgba(0,0,0, 0.85);
    -webkit-animation-name: zoomIn;
    animation-name: zoomIn
  }
  @-webkit-keyframes zoomOut {
    0% {
      z-index: 999;
      opacity: 1;
    }
    40% {
      z-index: 999;
    }
    50% {
      opacity: 0;
      transform: scale3d(.3,.3,.3)
    }
  }
  @keyframes zoomOut {
    0% {
      z-index: 999;
      opacity: 1
    }
    40% {
      z-index: 999;
    }
    50% {
      opacity: 0;
      transform: scale3d(.3,.3,.3)
    }
  }
  .zoomOut {
    -webkit-animation-name: zoomOut;
    animation-name: zoomOut
  }
}
.new-header-course{
  position: fixed;
  transition: background-color 0.5s;
  background-color: rgba(255,255,255,1);
  box-shadow: 0 4px 16px 0 rgba(0,0,0,0.1);
  .inner{
    .logo-text{
      color: #000;
    }
    .right-wrap{
      .item-wrap{
        &>div{
          &>div{
            span{
              color: #333;
            }
            &.active{
              span{
                color: #000;
              }
              div{
                border-bottom: 3px solid #000;
              }
            }
          }
        }
      }
      .login-wrap{
        .el-dropdown-link{
          span{
            color: #333;
          }
        }
        .login-not{
          color: #333;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/header.vue